import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { locales } from 'config/locales';
import { Autocomplete } from 'components/FormFields';
import { handleShowError, handleError, generateFilterOptions } from 'utils';

const LocalesSelect = ({
  label,
  variant,
  field: { name, value },
  form: { errors, touched, setFieldValue },
  omitFields,
  asyncErrors,
  margin,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [defaultValue, setDefaultValue] = useState(null);
  const filterOptions = generateFilterOptions('start', 'label');
  useEffect(() => {
    if (value || value === '') {
      const defaultVal = locales?.find((locale) => locale?.locale === value);
      if (defaultVal) {
        setDefaultValue(defaultVal);
      } else {
        setDefaultValue(null);
      }
    }
  }, [value, locales]) // eslint-disable-line

  return (
    <Autocomplete
      openOnFocus
      label={label}
      margin={margin}
      id="org-locales"
      variant={variant}
      options={locales}
      inputValue={inputValue}
      defaultValue={defaultValue}
      filterOptions={filterOptions}
      onInputChange={(ev, val) => setInputValue(val || '')}
      error={handleError(name, errors, touched, asyncErrors)}
      onChange={(ev, val) => setFieldValue(name, val?.locale || '')}
      helperText={handleShowError(name, errors, touched, asyncErrors)}
      getOptionSelected={(option, value) => option?.locale === (value?.locale || value) || ''}
      getOptionLabel={(option) =>
        i18n.t(`locales.${option?.locale}`, { defaultValue: option?.label || option })
      }
    />
  );
};

LocalesSelect.propTypes = {
  label: PropTypes.string,
  asyncErrors: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  style: PropTypes.object,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  omitFields: PropTypes.array,
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
};

LocalesSelect.defaultProps = {
  required: true,
  disabled: false,
  form: {
    errors: {},
    touched: {},
    setFieldValue: () => {},
  },
  style: {},
  field: {},
  omitFields: [],
  label: 'Locale',
  variant: 'standard',
};

export default LocalesSelect;
